export default "__VITE_ASSET__CzsWV4Fg__"